import { arrayBufferDownloadExcel } from "../../../../utils/download";
import {
  decorateEmptyGridValues,
} from "../../../../utils/table/gridUtils";
import {
  FETCH_AFFILIATE_REPORT_LIST,
  FETCH_AFFILIATE_REPORT_INIT,
  EXPORT_AFFILIATE_REPORT,
  DOWNLOAD_AFFILIATE_REPORT,
  EMAIL_AFFILIATE_REPORT,
  FETCH_AFFILIATE_LOCATION_DD,
  FETCH_AFFILIATE_NETWORK_DD,
  CLEAR_AFFILIATE_EMAIL_DROPDOWNS,
  TOAST,
  SET_AFFILIATE_REPORT_FILTERS,
  CLEAR_AFFILIATE_REPORT_FILTERS,
  SET_AFFILIATE_REPORT_TABLE_COLUMN_FILTERS,
  CLEAR_AFFILIATE_REPORT_TABLE_COLUMN_FILTERS,
  SAVE_AFFILIATE_REPORT_TABLE_STATE,
  FETCH_AFFILIATE_DEPENDENT_LOCATIONS_DD,
  FETCH_AFFILIATE_DEPENDENT_NETWORKS_DD,
  CLEAR_AFFILIATE_DEPENDENT_DROPDOWNS,
} from "../../../types/affiliateReport.type";

const INITIAL_STATE = {
  affiliateReportListview: [],
  isLoading: false,
  isLoadingPage: false,
  isEmailSending: false,
  isEmailSuccess: false,
  isEmailError: false,
  error: null,
  paginationInfo: null,
  isPageLevelError: false,
  isAffiliateReportExportSuccess: false,
  isAffiliateReportExportError: false,
  reportFilters: {
    startDate: null,
    endDate: null,
    locationId: [],
    networkId: [],
    affiliateId: [],
    status: null,
    type: null,
  },
  tableColumnFilters: {},
  savedTableState: null,
  affiliateLocationDD: [],
  affiliateNetworkDD: [],
  isLoadingAffiliateDD: false,
  affiliateDependentLocationsDD: [],
  affiliateDependentNetworksDD: [],
  isLoadingAffiliateDependentDD: false,
  affiliateReportSummary: null,
};

const transformToGridView = (data) => {
  const rows = data.map((item) => {
    const {
      reservationId,
      ref,
      pickupDate,
      pickupTime,
      dropoffDate,
      dropoffTime,
      totalAmount,
      commissionAmount,
      reservationStatus,
      createdTime,
      locationName,
      networkName,
      affiliateName,
      renterFirstName,
      renterLastName,
      renterEmail,
    } = item;

    const transformedValues = {
      id: reservationId,
      ref,
      pickupDate,
      pickupTime,
      dropoffDate,
      dropoffTime,
      totalAmount: totalAmount ? `$${totalAmount.toFixed(2)}` : "-",
      commissionAmount: commissionAmount ? `$${commissionAmount.toFixed(2)}` : "-",
      reservationStatus,
      createdTime,
      locationName,
      networkName,
      affiliateName,
      renterName: `${renterFirstName || ""} ${renterLastName || ""}`.trim(),
      renterEmail,
    };

    const decoratedValues = {};
    Object.keys(transformedValues).forEach((key) => {
      decoratedValues[key] = decorateEmptyGridValues(transformedValues[key]);
    });
    return decoratedValues;
  });

  const columns = [
    {
      colLabel: "Ref",
      dataKey: "ref",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: false,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Affiliate",
      dataKey: "affiliateName",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: false,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Commission Amount",
      dataKey: "commissionAmount",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: false,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Location",
      dataKey: "locationName",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: false,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Network",
      dataKey: "networkName",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: false,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Renter Name",
      dataKey: "renterName",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: false,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Renter Email",
      dataKey: "renterEmail",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: false,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Pickup Date",
      dataKey: "pickupDate",
      extraProps: {
        isSortable: true,
        isDateField: true,
        shouldFilter: false,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Pickup Time",
      dataKey: "pickupTime",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: false,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Dropoff Date",
      dataKey: "dropoffDate",
      extraProps: {
        isSortable: true,
        isDateField: true,
        shouldFilter: false,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Dropoff Time",
      dataKey: "dropoffTime",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: false,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Total Amount",
      dataKey: "totalAmount",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: false,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Status",
      dataKey: "reservationStatus",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: false,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Created Time",
      dataKey: "createdTime",
      extraProps: {
        isSortable: true,
        isDateField: true,
        shouldFilter: false,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
  ];

  return {
    datas: { columns, rows },
  };
};

export const affiliateReportReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_AFFILIATE_REPORT_INIT:
      return {
        ...INITIAL_STATE,
        reportFilters: state.reportFilters,
        tableColumnFilters: state.tableColumnFilters,
        savedTableState: state.savedTableState,
        isLoadingPage: false,
      };
    case EXPORT_AFFILIATE_REPORT.START:
    case FETCH_AFFILIATE_REPORT_LIST.START:
      return { ...state, isLoading: true };

    case FETCH_AFFILIATE_REPORT_LIST.SUCCESS: {
      const payload = action.payload;
      const { page, data } = payload;
      
      const summary = {
        totalCommissionAmount: payload.totalCommissionAmount,
        confirmedReservationCount: payload.confirmedReservationCount,
        confirmedReservationAmount: payload.confirmedReservationAmount,
        cancelledReservationCount: payload.cancelledReservationCount,
        cancelledReservationAmount: payload.cancelledReservationAmount,
        noshowReservationCount: payload.noshowReservationCount,
        noshowReservationAmount: payload.noshowReservationAmount,
      };

      let resetState = {
        affiliateReportListview: [],
        paginationInfo: null,
        error: null,
        isLoading: false,
        isLoadingPage: false,
        isPageLevelError: false,
        reportFilters: state.reportFilters,
        tableColumnFilters: state.tableColumnFilters,
        savedTableState: state.savedTableState,
        affiliateReportSummary: summary,
        affiliateDependentLocationsDD: state.affiliateDependentLocationsDD,
        affiliateDependentNetworksDD: state.affiliateDependentNetworksDD,
      };

      if (!data || data.length === 0) {
        return {
          ...resetState,
          affiliateReportListview: { columns: [], rows: [] },
        };
      }

      const { number, size, totalElements, totalPages } = page;
      const { datas } = transformToGridView(data);

      return {
        ...resetState,
        affiliateReportListview: datas,
        paginationInfo: {
          pageSize: size,
          totalRecords: totalElements,
          totalPages: totalPages,
          pageNumber: number,
        },
      };
    }

    case FETCH_AFFILIATE_REPORT_LIST.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        affiliateReportListview: { columns: [], rows: [] },
        isLoading: false,
        isLoadingPage: false,
        error,
        isPageLevelError: true,
      };
    }

    case EXPORT_AFFILIATE_REPORT.SUCCESS: {
      const data = action.payload;
      arrayBufferDownloadExcel(data, "affiliate-report.xls");
      return {
        ...state,
        isLoading: false,
        isAffiliateReportExportSuccess: true,
        isAffiliateReportExportError: false,
      };
    }

    case EXPORT_AFFILIATE_REPORT.ERROR: {
      const { error } = action.payload;
      return {
        ...state,
        isLoading: false,
        error,
        isAffiliateReportExportSuccess: false,
        isAffiliateReportExportError: true,
      };
    }

    case TOAST.RESET:
      return {
        ...state,
        isAffiliateReportExportSuccess: false,
        isAffiliateReportExportError: false,
      };

    case DOWNLOAD_AFFILIATE_REPORT.START:
      return { ...state, isLoading: true };

    case DOWNLOAD_AFFILIATE_REPORT.SUCCESS: {
      const data = action.payload;
      arrayBufferDownloadExcel(data, "affiliate-report.xls");
      return {
        ...state,
        isLoading: false,
      };
    }

    case DOWNLOAD_AFFILIATE_REPORT.ERROR:
      return {
        ...state,
        isLoading: false,
      };

    case EMAIL_AFFILIATE_REPORT.START:
      return { ...state, isEmailSending: true, isEmailSuccess: false, isEmailError: false };

    case EMAIL_AFFILIATE_REPORT.SUCCESS:
      return {
        ...state,
        isEmailSending: false,
        isEmailSuccess: true,
        isEmailError: false,
      };

    case EMAIL_AFFILIATE_REPORT.ERROR:
      return {
        ...state,
        isEmailSending: false,
        isEmailSuccess: false,
        isEmailError: true,
      };

    case SET_AFFILIATE_REPORT_FILTERS:
      return {
        ...state,
        reportFilters: { ...state.reportFilters, ...action.payload },
      };

    case CLEAR_AFFILIATE_REPORT_FILTERS:
      return {
        ...state,
        reportFilters: {
          startDate: null,
          endDate: null,
          locationId: [],
          networkId: [],
          affiliateId: [],
          status: null,
          type: null,
        },
      };

    case SET_AFFILIATE_REPORT_TABLE_COLUMN_FILTERS:
      return {
        ...state,
        tableColumnFilters: { ...state.tableColumnFilters, ...action.payload },
      };

    case CLEAR_AFFILIATE_REPORT_TABLE_COLUMN_FILTERS:
      return {
        ...state,
        tableColumnFilters: {},
      };

    case SAVE_AFFILIATE_REPORT_TABLE_STATE:
      return {
        ...state,
        savedTableState: action.payload,
      };

    case FETCH_AFFILIATE_LOCATION_DD.START:
    case FETCH_AFFILIATE_NETWORK_DD.START:
      return { ...state, isLoadingAffiliateDD: true };

    case FETCH_AFFILIATE_LOCATION_DD.SUCCESS:
      return {
        ...state,
        isLoadingAffiliateDD: false,
        affiliateLocationDD: action.payload || [],
      };

    case FETCH_AFFILIATE_LOCATION_DD.ERROR:
      return {
        ...state,
        isLoadingAffiliateDD: false,
        affiliateLocationDD: [],
      };

    case FETCH_AFFILIATE_NETWORK_DD.SUCCESS:
      return {
        ...state,
        isLoadingAffiliateDD: false,
        affiliateNetworkDD: action.payload || [],
      };

    case FETCH_AFFILIATE_NETWORK_DD.ERROR:
      return {
        ...state,
        isLoadingAffiliateDD: false,
        affiliateNetworkDD: [],
      };

    case CLEAR_AFFILIATE_EMAIL_DROPDOWNS:
      return {
        ...state,
        affiliateLocationDD: [],
        affiliateNetworkDD: [],
      };

    case FETCH_AFFILIATE_DEPENDENT_LOCATIONS_DD.START:
    case FETCH_AFFILIATE_DEPENDENT_NETWORKS_DD.START:
      return { ...state, isLoadingAffiliateDependentDD: true };

    case FETCH_AFFILIATE_DEPENDENT_LOCATIONS_DD.SUCCESS:
      return {
        ...state,
        isLoadingAffiliateDependentDD: false,
        affiliateDependentLocationsDD: action.payload || [],
      };

    case FETCH_AFFILIATE_DEPENDENT_LOCATIONS_DD.ERROR:
      return {
        ...state,
        isLoadingAffiliateDependentDD: false,
        affiliateDependentLocationsDD: [],
      };

    case FETCH_AFFILIATE_DEPENDENT_NETWORKS_DD.SUCCESS:
      return {
        ...state,
        isLoadingAffiliateDependentDD: false,
        affiliateDependentNetworksDD: action.payload || [],
      };

    case FETCH_AFFILIATE_DEPENDENT_NETWORKS_DD.ERROR:
      return {
        ...state,
        isLoadingAffiliateDependentDD: false,
        affiliateDependentNetworksDD: [],
      };

    case CLEAR_AFFILIATE_DEPENDENT_DROPDOWNS:
      return {
        ...state,
        affiliateDependentLocationsDD: [],
        affiliateDependentNetworksDD: [],
      };

    default:
      return state;
  }
};
